import { MoneyInput } from '../../components/MoneyInput/MoneyInput';
import { Button } from '../../components/Button/Button';
import { fmtN } from '../../lib/format';
import { MONTH_SHORT } from '../../lib/dates';
import type { Depot } from '@budgetx/shared';
import styles from './DepotMaanedTable.module.css';

interface Props {
  year: number;
  monthIdx: number;
  depots: Depot[];
  onAdd(): void;
  onRename(depotId: number, name: string): void;
  onDelete(depotId: number, name: string): void;
  onEditAmount(depotId: number, month: number, next: number | null): void;
}

export function DepotMaanedTable({
  year,
  monthIdx,
  depots,
  onAdd,
  onRename,
  onDelete,
  onEditAmount,
}: Props) {
  const totals: (number | null)[] = Array(12).fill(null);
  for (let m = 0; m < 12; m++) {
    let sum = 0;
    let any = false;
    for (const d of depots) {
      const v = d.amounts[m];
      if (v !== null && v !== undefined) {
        sum += v;
        any = true;
      }
    }
    totals[m] = any ? sum : null;
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.headRow}>
        <h2 className={styles.title}>Aktier &amp; depoter · {year}</h2>
        <Button onClick={onAdd}>+ Tilføj depot</Button>
      </div>
      <div className={styles.scroll}>
        <div className={styles.inner}>
          <div className={styles.headRow2}>
            <div className={styles.depotCol}>Depot</div>
            {MONTH_SHORT.map((m, i) => (
              <div
                key={m}
                className={`${styles.monthCell} ${i === monthIdx ? styles.monthCurrent : ''}`}
              >
                {m}
              </div>
            ))}
          </div>
          {depots.map((d) => (
            <div key={d.id} className={styles.depotRow}>
              <div className={styles.depotNameWrap}>
                <input
                  className={styles.depotNameInput}
                  value={d.name}
                  onChange={(e) => onRename(d.id, e.target.value)}
                  onFocus={(e) => e.target.select()}
                />
                <button
                  type="button"
                  className={styles.deleteBtn}
                  onClick={() => onDelete(d.id, d.name)}
                  title={`Slet depotet ${d.name}`}
                  aria-label={`Slet depotet ${d.name}`}
                >
                  ×
                </button>
              </div>
              {MONTH_SHORT.map((_, m) => (
                <MoneyInput
                  key={m}
                  value={d.amounts[m] ?? null}
                  onCommit={(v) => onEditAmount(d.id, m, v)}
                  placeholder="—"
                />
              ))}
            </div>
          ))}
          <div className={styles.totalRow}>
            <div className={styles.totalLabel}>I alt</div>
            {totals.map((v, m) => (
              <div
                key={m}
                className={styles.totalCell}
                style={{ color: m === monthIdx ? 'var(--accent-dark)' : 'var(--text)' }}
              >
                {v === null ? '—' : fmtN(v)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
